'use client'
import * as React from 'react'
import { usePathname } from 'next/navigation'
import { reservedRepoSlugs, reservedTeamSlugs } from '../lib/reserved-routes'
import { useUserStore } from '~/app/_store/user-store'
import { create } from 'zustand'

export const DashboardSlugsSetUp = () => {
  const { optimisticUser, isLoading: isUserLoading } = useUserStore()
  // TODO c'mon Next.js, there must be a better way to do this... :(((
  // issue ref: https://github.com/vercel/next.js/issues/43704
  const pathname = usePathname()

  // sync w zustand
  React.useEffect(() => {
    const splitted = pathname?.split('/') ?? []
    const teamSlugQuery = splitted[1]
    const repoSlugQuery = splitted[2]
    const repoPageQuery = splitted[3]
    const branchOrCommitQuery = splitted[4]
    const blockIdQuery = splitted[5]
    const isLoading = pathname === null || isUserLoading

    const teamSlug = getTeamSlug(
      teamSlugQuery,
      optimisticUser?.username ?? null
    )
    const repoSlug = getRepoSlug(repoSlugQuery)
    const repoPage = repoPageQuery ?? null
    const branchOrCommit = branchOrCommitQuery
      ? decodeURIComponent(branchOrCommitQuery)
      : null
    const blockId = blockIdQuery ?? null

    useDashboardSlugs.setState({
      isLoading,
      teamSlug,
      repoSlug,
      repoPage,
      branchOrCommit,
      activeTabKey: blockId,
    })
  }, [isUserLoading, optimisticUser?.username, pathname])

  return null
}

type DashboardSlugsStore = {
  isLoading: boolean
  teamSlug: string | null
  repoSlug: string | null
  repoPage: string | null
  branchOrCommit: string | null
  activeTabKey: string | null
}

export const useDashboardSlugs = create<DashboardSlugsStore>(() => {
  return {
    isLoading: true,
    teamSlug: null,
    repoSlug: null,
    repoPage: null,
    branchOrCommit: null,
    activeTabKey: null,
  }
})

function getTeamSlug(
  teamSlugQuery: string | undefined,
  username: string | null
) {
  if (typeof teamSlugQuery === 'string') {
    if (!reservedTeamSlugs.includes(teamSlugQuery)) return teamSlugQuery
    else return null
  }
  return username
}

function getRepoSlug(repoSlugQuery: string | undefined) {
  if (typeof repoSlugQuery === 'string') {
    if (!reservedRepoSlugs.includes(repoSlugQuery)) return repoSlugQuery
  }
  return null
}
